import { GridColDef } from '@mui/x-data-grid';
import { CreativeRequest } from 'API';
import CreativeVideoThumbnail from './CreativeVideoThumbnail';
import { getStatusLabel, requestsSortComparator } from './utils';

export enum BrandLoginViewTabs {
  EverydayContent = 'Everyday content',
  ComingSoon = 'Coming Soon',
}

export const TABLE_COLUMNS: GridColDef[] = [
  {
    field: 'preview',
    headerName: 'Preview',
    headerAlign: 'center',
    sortable: false,
    filterable: false,
    cellClassName: 'px-10',
    minWidth: 150,
    renderCell: ({ row }) =>
      row.tiktokCreativeUrl && (
        <CreativeVideoThumbnail videoPath={row.tiktokCreativeUrl} />
      ),
  },
  {
    field: 'briefName',
    headerName: 'Activation',
    flex: 1,
    renderCell: ({ row }) => row.brief?.BriefName || 'N/A',
  },
  {
    field: 'uniqueId',
    headerName: 'Creative Id',
    filterable: false,
    align: 'center',
    headerAlign: 'center',
    flex: 1,
  },
  {
    field: 'status',
    headerAlign: 'center',
    headerName: 'Status',
    filterable: false,
    sortable: true,
    align: 'center',
    flex: 1,
    sortComparator: requestsSortComparator,
    renderCell: ({ value }) => getStatusLabel({ status: value }),
  },
  {
    field: 'details',
    headerAlign: 'center',
    headerName: 'Details',
    align: 'center',
    filterable: false,
    sortable: false,
    flex: 1,
  },
];

export const MOCK_CREATIVE_REQUESTS = [
  {
    id: 'c0d4352a-60b6-4a29-a2e9-5e20dbb507c4',
    brandBriefId: '05939503-3b2a-4d21-aaa8-0d565e9e2a36',
    status: 'Submitted',
    creatorId: '',
    tiktokCreativeUrl:
      'creative/c0d4352a-60b6-4a29-a2e9-5e20dbb507c4/89e22b9d-a379-4c01-ab25-47130e9d1668.mp4',
    creativePreviewUrl: null,
    tiktokVideoCode: '',
    brandComment: [],
    adminComment: [],
    creatorComment: [],
    adminApproval: null,
    creatorVisibility: null,
    createdAt: '2024-06-14T06:57:05.872Z',
    updatedAt: '2024-06-14T06:57:21.164Z',
    uniqueId: 'MET-7985',
    approvedAds: { items: [], __typename: 'ModelApprovedAdsConnection' },
    brief: {
      id: '05939503-3b2a-4d21-aaa8-0d565e9e2a36',
      BriefName: 'META TEST',
      vertical: 'nonprofit-and-social-impact',
      objective: 'META TEST',
      brandBriefDetails: 'META TEST',
      brandBriefFilesUrl: '',
      active: true,
      brandId: '178a2a80-2330-4648-b534-dc554e75bb91',
      brandProfile: [Object],
      __typename: 'BrandBrief',
    },
    creatorProfile: {
      id: '6957c2fe-9cb3-45b1-a736-31b9c060d79c',
      uniqueId: '6030959',
      email: 'melkon+stagingcreator@edcsquared.io',
      name: 'Staging creator',
      hashtags: [Array],
      description: 'asdf',
      userType: 'CREATIVE_USER',
      tiktokHandler: 'https://tiktok.com/@katapult333',
      youtubeHandler: 'https://www.youtube.com/@melkonhovhannisian',
      instagramHandler: 'https://instagram/undefined',
      phoneNumber: '',
      country: 'AR',
      avatar:
        'https://user-storage91541-master.s3.amazonaws.com/public/6957c2fe-9cb3-45b1-a736-31b9c060d79c/avatar/profile',
      vertical: null,
      termsAndConditions: true,
      createdAt: '2024-04-09T14:45:08.737Z',
      updatedAt: '2024-06-07T11:30:32.716Z',
      __typename: 'UserProfile',
    },
    __typename: 'CreativeRequest',
  },
] as unknown as CreativeRequest[];

export const MOCK_TABLE_DATA = [{ id: 'fake id' }];
